import PolicyLayout from "@/components/PolicyLayout";

const sections = [
    {
        heading: "1. Acceptance",
        body: [
            "By accessing nexuspeptides.online you confirm that you are at least 18 years old, that you are a qualified researcher or acting on behalf of a research institution, and that you accept these Terms in full. If you do not accept these Terms you must stop using the site immediately.",
        ],
    },
    {
        heading: "2. Research-use-only products",
        body: [
            "All products listed on this site are sold strictly for in-vitro laboratory research purposes. They are not medicines. They are not approved by the FDA, EMA, MHRA, or any other regulatory authority for clinical use. They are not intended for human or veterinary consumption, ingestion, injection, topical application, or any clinical, therapeutic, diagnostic, or cosmetic use.",
            "By placing an order you certify that the products will be used only for in-vitro research by qualified personnel and stored, handled, and disposed of in accordance with applicable safety regulations.",
        ],
    },
    {
        heading: "3. The partner lab relationship",
        body: [
            "Nexus Peptides is a distributor. Products are synthesised, lyophilised, and quality-controlled at our partner lab. Nexus is responsible for the storefront, customer relationship, dispatch, and post-sale support; the partner lab is responsible for synthesis, analytical testing, and the issuance of each Certificate of Analysis.",
        ],
    },
    {
        heading: "4. Accounts",
        body: [
            "You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. Notify us immediately at info@nexuspeptides.online if you suspect any unauthorised use.",
        ],
    },
    {
        heading: "5. Orders, pricing and payment",
        body: [
            "Prices are listed in Pounds Sterling (GBP, £) and may change without notice. All orders are subject to acceptance and product availability. We may refuse, cancel, or limit any order at our sole discretion, including where pricing or stock errors are identified.",
            "Payment is taken at the time of checkout. Payment information is processed by our payment provider and is not stored in full on our servers — only a truncated reference (last four digits) is retained on your order record.",
        ],
    },
    {
        heading: "6. Shipping",
        body: [
            "Orders ship from our partner lab via insulated cold-chain packaging where required. Shipping timeframes are estimates and depend on the carrier and destination. Title and risk of loss pass to you on delivery.",
        ],
    },
    {
        heading: "7. Returns and refunds",
        body: [
            "Due to the nature of research compounds we cannot accept returns of opened products. If a product arrives damaged or non-conforming to the Certificate of Analysis, contact info@nexuspeptides.online within seven days of delivery and we will arrange a replacement or refund.",
        ],
    },
    {
        heading: "8. Intellectual property",
        body: [
            "All site content — including text, images, branding, product photography, and the Nexus Peptides name and logo — is owned by Nexus Peptides or its licensors and is protected by intellectual property laws. You may not copy, reproduce, distribute, or create derivative works without our prior written consent.",
        ],
    },
    {
        heading: "9. Disclaimer of warranties",
        body: [
            "Products and information on this site are provided \"as is\" without warranties of any kind, whether express or implied, including implied warranties of merchantability or fitness for a particular purpose. The Certificate of Analysis supplied with each product is the sole warranty of identity and purity.",
        ],
    },
    {
        heading: "10. Limitation of liability",
        body: [
            "To the maximum extent permitted by law, Nexus Peptides will not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the site or our products. Our total liability for any claim relating to a product is limited to the amount you paid for that product.",
        ],
    },
    {
        heading: "11. Indemnity",
        body: [
            "You agree to indemnify and hold Nexus Peptides and our partner lab harmless from any claim, loss, or damage arising from your misuse of the products — including any use that is contrary to the research-use-only restriction in Section 2.",
        ],
    },
    {
        heading: "12. Governing law",
        body: [
            "These Terms are governed by the laws of England and Wales. Any disputes will be resolved exclusively in the courts of England and Wales, save that if you are a consumer resident in another part of the United Kingdom you may bring proceedings in the courts of the part of the UK in which you are resident.",
        ],
    },
    {
        heading: "13. Changes",
        body: [
            "We may update these Terms from time to time. Continued use of the site after changes are posted constitutes your acceptance of the updated Terms.",
        ],
    },
    {
        heading: "14. Contact",
        body: ["Questions about these Terms can be sent to info@nexuspeptides.online."],
    },
    {
        heading: "15. Company details",
        body: [
            "Coresight Creative Limited",
            "128 City Road, London, United Kingdom, EC1V 2NX",
            "Registered in England and Wales, company number 16828110",
            "Contact: info@nexuspeptides.online",
        ],
    },
];

export default function Terms() {
    return (
        <PolicyLayout
            eyebrow="// Legal"
            title="Terms & conditions"
            intro="These Terms govern your access to and use of nexuspeptides.online and any purchase you make through the site. Please read them carefully. By using the site you agree to be bound by these Terms."
            sections={sections}
            footer="This document is provided for general information only and does not constitute legal advice. Please consult qualified legal counsel for advice on your specific situation."
        />
    );
}
